import * as React from 'react';

import Control from '../control';
import classNames from 'classnames';
import { OptoutProps } from './common';

import styles from './icon.scss';
import OguryIcon from './ogury-icon';

export default function OptOutIcon({
  onClick,
  iconSize = 16,
  iconPadding = 4,
  useContainerStyle = true,
  iconStyle = { filter: 'drop-shadow(rgba(0, 0, 0, 0.5) 0px 1px 1px)' },
  iconColor = '#FFFFFF',
  style = {},
  controlBlockStyle = { padding: 4 },
  childPrivacyApplied = false,
  id = 'optout'
}: OptoutProps) {
  return (
    <div data-zone="optout" style={{ position: 'relative' }}>
      <Control
        id={id}
        onTouchStart={e => e.stopPropagation()}
        onClick={(e: React.MouseEvent) => {
          onClick(e);
        }}
        iconSize={iconSize}
        useContainerStyle={useContainerStyle}
        controlBlockStyle={controlBlockStyle}
      >
        <>
          {childPrivacyApplied ? (
            <div className={classNames(styles.icon, styles.childPrivacyIcon)}>
              <OguryIcon iconColor={iconColor} />
            </div>
          ) : (
            <div
              style={{
                height: iconSize + iconPadding * 2,
                width: iconSize + iconPadding * 2,
                padding: iconPadding,
                ...style
              }}
              className={styles.icon}
            >
              <svg
                viewBox="0 0 30 30"
                width={iconSize}
                height={iconSize}
                xmlns="http://www.w3.org/2000/svg"
                className={styles.iconStyle}
                style={iconStyle}
              >
                <g fill={iconColor}>
                  <g>
                    <circle r="1.470929" cy="8.625972" cx="14.511199" />
                    <path d="m16.021747,19.898431l0,-7.844958l-3.922479,0l0,1.96124l1.96124,0l0,5.883719l-1.96124,0l0,1.96124l5.883719,0l0,-1.96124" />
                  </g>
                  <path d="m15,0.290704c-8.125474,0 -14.709296,6.583822 -14.709296,14.709296c0,8.125474 6.583822,14.709296 14.709296,14.709296c8.125474,0 14.709296,-6.583822 14.709296,-14.709296c0,-8.125474 -6.583822,-14.709296 -14.709296,-14.709296zm-0.050816,27.447233c-7.392304,0.01012 -12.697241,-5.336042 -12.697241,-12.742997c0,-7.317502 5.297955,-12.742997 12.697241,-12.742997c7.272296,0 12.798873,5.418493 12.697241,12.742997c0.101631,7.399953 -5.424945,12.753117 -12.697241,12.743016l0,-0.00002z" />
                </g>
              </svg>
            </div>
          )}
        </>
      </Control>
    </div>
  );
}
